var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#1D68B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 4.80076C16.9913 4.59209 16.7436 4.42657 16.471 4.31363C16.1984 4.2007 15.9062 4.14258 15.6111 4.14258C15.316 4.14258 15.0238 4.2007 14.7512 4.31363C14.4786 4.42657 14.2309 4.59209 14.0223 4.80076L5.57255 13.2505C5.32113 13.5019 5.13827 13.8139 5.04284 14.1568L4.15884 17.3139C4.13842 17.3871 4.13782 17.4644 4.1571 17.5379C4.17639 17.6114 4.21486 17.6784 4.26859 17.7321C4.32232 17.7859 4.38937 17.8244 4.46286 17.8436C4.53635 17.8629 4.61365 17.8623 4.68684 17.8419L7.84341 16.9579C8.18623 16.862 8.49856 16.6793 8.75027 16.4276L17.2 7.9779C17.6212 7.55655 17.8579 6.98514 17.8579 6.38933C17.8579 5.79352 17.6212 5.22211 17.2 4.80076ZM14.6286 5.40647C14.8892 5.14588 15.2427 4.99951 15.6113 4.99956C15.9799 4.99961 16.3334 5.14609 16.594 5.40676C16.8546 5.66743 17.0009 6.02094 17.0009 6.38953C17.0008 6.75812 16.8544 7.11159 16.5937 7.37219L15.7137 8.25161L13.7486 6.2859L14.6286 5.40647ZM13.1428 6.89219L15.1086 8.8579L8.14398 15.8219C7.99647 15.9694 7.81345 16.0765 7.61255 16.1328L5.18913 16.811L5.86741 14.3882C5.92378 14.1873 6.03082 14.0043 6.17827 13.8568L13.1428 6.89219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.f1a913b98d43bfca3533782d403480f8.svg";
export { ForwardRef as ReactComponent };